export default "__VITE_ASSET__b80bf69b__"